import { Component, OnInit } from '@angular/core';
import { PostitModel } from '../../models/postit.model';
import { PostitService } from '../../services/postit.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector   : 'my-postits',
    template: require('./postits.component.html'),
    styles: [require('./postits.component.scss')]
})

export class PostitsComponent implements OnInit {

    isArchive: boolean        = false;
    buttons: any;

    constructor(public postitService: PostitService, private route: ActivatedRoute, private router: Router) {
        this.buttons = {
            'left'  : [],
            'center': [
                {
                    'title' : 'Nouveau Post-it',
                    'style' : 'primary',
                    'action': 'newPostit',
                    'model' : this,
                    'icon'  : 'fa-plus'
                },
            ],
            'right' : [
                {
                    'title' : 'Afficher les supprimés',
                    'style' : 'secondary',
                    'action': 'openArchive',
                    'model' : this,
                    'icon'  : 'fa-file-archive-o'
                }
            ],
        };
    }

    ngOnInit(): void {
        this.route.params.subscribe(params=> {
            if (params['archive']) {
                this.postitService.loadAll(true);
                this.buttons = {
                    'left'  : [],
                    'center': [],
                    'right' : [
                        {
                            'title' : 'Afficher les Post-it',
                            'style' : 'secondary',
                            'action': 'openArchive',
                            'model' : this,
                            'icon'  : 'fa-file-archive-o'
                        }
                    ],
                };
                this.isArchive              = true;
            } else {
                this.postitService.loadAll(false);
                this.buttons = {
                    'left'  : [],
                    'center': [
                        {
                            'title' : 'Nouveau Post-it',
                            'style' : 'primary',
                            'action': 'newPostit',
                            'model' : this,
                            'icon'  : 'fa-plus'
                        },
                    ],
                    'right' : [
                        {
                            'title' : 'Afficher les supprimés',
                            'style' : 'secondary',
                            'action': 'openArchive',
                            'model' : this,
                            'icon'  : 'fa-file-archive-o'
                        }
                    ],
                };
                this.isArchive = false;
            }
        });
    }

    eventDelete(event) {
        for (let i = this.postitService.postitList.length - 1; i >= 0; i--) {
            if (this.postitService.postitList[i].privateId === event) {
                this.postitService.postitList.splice(i, 1);
            }
        }
    }

    newPostit() {
        this.postitService.postitList.unshift(new PostitModel(this.postitService));
    }

    openArchive() {
        if (this.isArchive)
            this.router.navigate(['postit']);
        else
            this.router.navigate(['postit', 'archive']);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/pages/postits/postits.component.ts